import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push, replace } from "react-router-redux";
import PropTypes from "prop-types";
import cx from "classnames";
import stringSimilarity from "string-similarity";
import {
  REGISTRATION_ANALYTICS_PHASE,
  PAYMENT_ANALYTICS_PHASE
} from "../../constants/general";
import { changeDateToMomentFormat } from "../../helpers/dateHelpers";
import { removeHTMLFromString } from "../../helpers/domHelpers";
import {
  isRTL,
  availablePaxList,
  getCartTotalPrices,
  getSelectedHotelName
} from "../../reducers";
import {
  setRegistrationData,
  setTotalAmount,
  setOrderCurrency,
  getClubLLoggedUserData
} from "../../actions/registrationActions";
import * as addonsActions from "../../actions/addonsActions";
import {
  getAnalyticsPlaceHolders,
  clearAnalyticsPlaceHolders
} from "../../actions/placeHoldersActions";
import {
  getPaymentData,
  setReservation,
  payPalProxy
} from "../../actions/paymentActions";
import { setOrderSummary } from "../../actions/orderSummaryActions";
import RegistrationForm from "../../components/RegistrationForm";
import Payment from "../../components/Payment/Payment";
import ClubBanner from "../../components/ClubBanner";
import AddonCarouselGroup from "../../components/AddonCarouselGroup";
import { PlaceHolder } from "../../components/common";
import styles from "./styles.less";

class RegistrationPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionId: null,
      paymentFormVisible: false
    };
    this.setOrderSummary();
    // window.addEventListener(
    //   "beforeunload",
    //   this.showDialogBeforUnloading.bind(this)
    // );
  }

  componentDidMount() {
    // onLoad from generalHandlers of ScrollManager wrapper:
    // check whether scrolling up should be done, if do, scroll.
    const {
      actions,
      orderCurrency,
      lang,
      selectedHotelId,
      paxList,
      checkinDate,
      checkoutDate,
      promoCode
    } = this.props;
    const totalAmountToPay = this.calcTotalAmountToPayInludingSpecialServices();
    const checkinDateMoment = changeDateToMomentFormat(checkinDate, ".");
    const checkoutDateMoment = changeDateToMomentFormat(checkoutDate, ".");
    const totalNights = checkoutDateMoment.diff(checkinDateMoment, "days");
    let orderDescription = "";
    paxList.map(pax => {
      orderDescription += pax.roomId + ", ";
    });
    let req = {
      amount: totalAmountToPay,
      currency: orderCurrency && orderCurrency.currencyCode,
      lang,
      hotelId: selectedHotelId,
      orderDescription,
      totalNights,
      promoCode: promoCode
    };
    setTimeout(this.props.onLoad(), 0);
    actions.getPaymentData(req);
  }

  /** each update, check if payment confirmed, if so, redirect to confirmation.
   * payment confirmed by checking if valid token or transactionId is stored and has new value.
   */
  componentDidUpdate = prevProps => {
    const { isPayPal, transactionId, token, selectedAddonsGroup } = this.props;
    const { paymentFormVisible } = this.state;
    if (isPayPal != null && !isPayPal) {
      if (
        prevProps.transactionId != transactionId &&
        transactionId != null &&
        transactionId.length > 0
      ) {
        this.continueToConfirmation();
      }
    } else {
      if (prevProps.token != token && token != null && token.length > 0) {
        this.continueToConfirmation();
      }
    }
    if (
      paymentFormVisible &&
      prevProps.selectedAddonsGroup != selectedAddonsGroup
    ) {
      this.continueToPayment();
    }
  };

  componentWillUnmount() {
    window.beforeunload = null;
  }

  /**
   * Get analytics code from server and append it to #page-analytics-wrapper element ( append action include the execution ).
   * Generate the code with the data stored until this phase ( ex, no masterid )
   */
  getRegistrationAnalyticsPlaceHolders = () => {
    const {
      selectedHotelId,
      checkinDate,
      checkoutDate,
      promoCode,
      hotelName,
      orderSummary,
      orderCurrency,
      actions
    } = this.props;
    const rooms = orderSummary.map(r => ({
      RoomsId: r.id,
      Price: r.price
    }));
    const postObject = {
      Phase: REGISTRATION_ANALYTICS_PHASE,
      Currency: orderCurrency && orderCurrency.currencyCode,
      HotelId: selectedHotelId,
      HotelName: hotelName,
      CheckInDate: checkinDate,
      CheckoutDate: checkoutDate,
      PromoCode: promoCode,
      Rooms: rooms
    };
    actions.getAnalyticsPlaceHolders(postObject);
  };
  getPaymentAnalyticsPlaceHolders = () => {
    // for now, its should be same model data as registration..
    const {
      selectedHotelId,
      checkinDate,
      checkoutDate,
      promoCode,
      hotelName,
      orderSummary,
      orderCurrency,
      actions
    } = this.props;
    const rooms = orderSummary.map(r => ({
      RoomsId: r.id,
      Price: r.price
    }));
    const postObject = {
      Phase: PAYMENT_ANALYTICS_PHASE,
      Currency: orderCurrency && orderCurrency.currencyCode,
      HotelId: selectedHotelId,
      HotelName: hotelName,
      CheckInDate: checkinDate,
      CheckoutDate: checkoutDate,
      PromoCode: promoCode,
      Rooms: rooms
    };
    actions.getAnalyticsPlaceHolders(postObject);
  };

  showDialogBeforUnloading = event => {
    event.preventDefault();
    return (event.returnValue = "");
  };

  onAddonRoomChanged = roomNum => {
    const { actions } = this.props;
    actions.setAddonsCurosselRoomNum(roomNum);
  };

  updateRegistrationData = registrationData => {
    const { actions } = this.props;
    actions.setRegistrationData(registrationData);
  };

  onSubmit = async registrationData => {
    const { actions, isNoPayment } = this.props;
    await actions.setRegistrationData(registrationData);
    if (!isNoPayment) {
      this.continueToPayment();
    } else {
      this.continueToConfirmation();
    }
  };

  togglePaymentSection = () => {
    this.setState(prevState => ({
      paymentFormVisible: !prevState.paymentFormVisible
    }));
  };

  /** set final step of reservation process - payment.
   * calculate all the relavent parameters for creditguard/pelecard and create tokened src url for the iframe.
   */
  continueToPayment = async () => {
    const {
      actions,
      orderCurrency,
      lang,
      selectedHotelId,
      paxList,
      checkinDate,
      checkoutDate,
      promoCode
    } = this.props;
    await this.calcAddonsForOrder();
    const totalAmountToPay = this.calcTotalAmountToPayInludingSpecialServices();
    const checkinDateMoment = changeDateToMomentFormat(checkinDate, ".");
    const checkoutDateMoment = changeDateToMomentFormat(checkoutDate, ".");
    const totalNights = checkoutDateMoment.diff(checkinDateMoment, "days");
    let orderDescription = "";
    paxList.map(pax => {
      orderDescription += pax.roomId + ", ";
    });
    let req = {
      amount: totalAmountToPay,
      currency: orderCurrency && orderCurrency.currencyCode,
      lang,
      hotelId: selectedHotelId,
      orderDescription,
      totalNights,
      promoCode: promoCode
    };
    actions.getPaymentData(req);
  };

  setOrderSummary = () => {
    const {
      isDealMode,
      dealSearchResults,
      rooms,
      clubUserLoggedIn,
      paxList,
      actions,
      titles
    } = this.props;
    let totalAmount = 0;
    let currencyCode = "";
    let currencySymbol = "";
    const result =
      paxList &&
      paxList.map((pax, index) => {
        /* Important!! we use the index for mapping the inputs
          because the pax.id can be off (if we removed a pax from the cart)
          server side needs the original index and not our modified index - sagiv. 
      */
        const releventRoom = !isDealMode
          ? rooms[pax.id].find(room => room.id === pax.roomId) || {}
          : dealSearchResults[pax.id].find(deal => deal.roomId === pax.roomId);

        const relevantRate = !isDealMode
          ? releventRoom && releventRoom.rates
            ? releventRoom.rates.find(rate => rate.id === pax.rateId) || {}
            : {}
          : releventRoom && releventRoom.rate;

        const roomCategoryName = releventRoom.pmsRoomCategory;
        const planName = relevantRate.planCode;
        const paxName = `${pax.Adults} Adults, ${pax.Children} Children, ${
          pax.Infants
        } Infants`;

        currencySymbol = relevantRate.currency;
        currencyCode = relevantRate.currencyCode;

        const totalPriceForSession = clubUserLoggedIn
          ? relevantRate && relevantRate.simpleClubTotalPrice
          : relevantRate && relevantRate.totalPrice;

        totalAmount += totalPriceForSession;

        const roomName = removeHTMLFromString(
          releventRoom && releventRoom.name
        );

        const paxChildren =
          pax.Children > 0 ? `${pax.Children} ${titles.Children}` : "";
        const paxInfants =
          pax.Infants > 0 ? `${pax.Infants} ${titles.Infants}` : "";
        const paxGuests =
          paxChildren != "" && paxInfants != ""
            ? `${pax.Adults} ${titles.Adults}, ${paxChildren}, ${paxInfants}`
            : paxChildren != ""
              ? `${pax.Adults} ${titles.Adults}, ${paxChildren}`
              : paxInfants != ""
                ? `${pax.Adults} ${titles.Adults}, ${paxInfants}`
                : `${pax.Adults} ${titles.Adults}`;
        const roomFullTitle = `${roomName}, ${paxGuests}`;
        let room = {};
        room.key = index;
        room.value = index;
        room.label = roomFullTitle;
        room.id = releventRoom.id;
        room.price = totalPriceForSession;
        room.name = releventRoom.name;
        room.pax = paxName;
        room.roomCategoryName = roomCategoryName;
        room.planName = planName;
        return room;
      });
    let currency = {
      currencyCode,
      currencySymbol
    };
    actions.setTotalAmount(totalAmount);
    actions.setOrderCurrency(currency);
    actions.setOrderSummary(result);
  };

  onAddonIncrementClick = (addonCode, msg) => {
    const { actions, addonsCurosselRoomNumber } = this.props;
    actions.onAddonAdd(addonsCurosselRoomNumber, addonCode, msg);
  };

  continueToConfirmation = () => {
    this.setReservation();
    this.redirectToConfirmation();
  };

  calcAddonsForOrder = async () => {
    const { selectedAddonsGroup, paxList, addons, actions } = this.props;
    const result =
      paxList &&
      paxList.map(pax => {
        let currentSelectedGroup = selectedAddonsGroup[pax.id];
        let selectedAddonsPerPax =
          currentSelectedGroup &&
          Object.entries(currentSelectedGroup).reduce(
            (result, [addonKey, count]) => {
              const relevantAddon = addons[pax.id].find(
                addon => addon.id === addonKey
              );
              if (relevantAddon) {
                result.push({
                  ID: relevantAddon.id,
                  Quantity: count,
                  Name: relevantAddon.name,
                  TotalPrice: relevantAddon.price * count
                });
              }
              return result;
            },
            []
          );
        return selectedAddonsPerPax;
      });
    await actions.setAddonsForOrder(result);
    return result;
  };

  calcTotalAmountToPayInludingSpecialServices = () => {
    const { addonsForOrder, totalAmountToPay } = this.props;
    let totalAmountSpecialServices = 0;
    addonsForOrder &&
      addonsForOrder.forEach(currentValue => {
        let sum = 0;
        currentValue &&
          currentValue.forEach(element => {
            sum += element.Quantity * element.TotalPrice;
          });
        totalAmountSpecialServices += sum;
      });
    return totalAmountToPay + Math.round(totalAmountSpecialServices);
  };

  redirectToConfirmation() {
    const { actions, routing } = this.props;
    actions.replace(
      {
        pathname: "/confirmation",
        search: routing.location.search
      },
      null
    );
  }

  async setReservation() {
    const {
      actions,
      registrationData,
      paxList,
      lang,
      transactionId,
      token,
      payerId,
      isPayPal,
      selectedHotelId,
      checkinDate,
      checkoutDate,
      promoCode,
      orderCurrency,
      isPromoCodeValid,
      addonsForOrder,
      userComments,
      discountClubConfig,
      clubUserLoggedIn,
      rooms
    } = this.props;
    let addonsForSetReservations = addonsForOrder;
    if (addonsForOrder === null || addonsForOrder.length === 0) {
      addonsForSetReservations = await this.calcAddonsForOrder();
    }
    let SelectedSessions = paxList.map((element, index) => {
      let currentRoom =
        rooms &&
        rooms[index] &&
        rooms[index].find(room => room.id.trim() === element.roomId.trim());
      let currentRate =
        currentRoom &&
        currentRoom.rates.find(rate => rate.id === element.rateId);
      return {
        sessionId: element.rateId,
        IsPackage: currentRate && currentRate.isPackage,
        SelectedServices:
          addonsForSetReservations && addonsForSetReservations[index]
      };
    });
    const loggedInToClub =
      discountClubConfig && discountClubConfig.Active && clubUserLoggedIn;
    const totalAmountToPay = this.calcTotalAmountToPayInludingSpecialServices();
    let req = {};
    if (isPayPal) {
      req = {
        SelectedHotelId: selectedHotelId,
        registrationData,
        CheckIn: checkinDate,
        CheckOut: checkoutDate,
        PromoCode: promoCode,
        IsPromoCodeValid: isPromoCodeValid,
        Lang: lang,
        token: token,
        payerId: payerId,
        currency: orderCurrency && orderCurrency.currencyCode,
        totalAmount: totalAmountToPay,
        loggedInToClub
      };
    } else {
      req = {
        SelectedHotelId: selectedHotelId,
        registrationData,
        CheckIn: checkinDate,
        CheckOut: checkoutDate,
        PromoCode: promoCode,
        IsPromoCodeValid: isPromoCodeValid,
        Lang: lang,
        TransactionId: transactionId,
        UserComments: userComments,
        loggedInToClub
      };
    }
    req.selectedSessions = SelectedSessions;
    actions.setReservation(req);
  }

  renderPaymentProcess() {
    const {
      payment,
      actions,
      titles,
      isMobileView,
      lang,
      transactionId,
      token,
      isRtl,
      discountClubConfig,
      orderCurrency,
      showSimpleClubLoginModal,
      totalAmountToPay,
      clubUserLoggedIn,
      isGlobalFetch,
      paymentUrlRequestStatus,
      placeHolders,
      domainUrl,
      enablePrePayment
    } = this.props;
    return (
      <Payment
        titles={titles}
        payment={payment}
        isMobileView={isMobileView}
        lang={lang}
        transactionId={transactionId}
        token={token}
        isRtl={isRtl}
        continueToConfirmation={this.continueToConfirmation}
        discountClubConfig={discountClubConfig}
        orderCurrency={orderCurrency}
        showSimpleClubLoginModal={showSimpleClubLoginModal}
        totalAmountToPay={totalAmountToPay}
        clubUserLoggedIn={clubUserLoggedIn}
        isFetchingPaymentData={isGlobalFetch}
        paymentUrlRequestStatus={paymentUrlRequestStatus}
        resetPayment={this.continueToPayment}
        placeHolders={placeHolders}
        getAnalyticsPlaceHolders={this.getPaymentAnalyticsPlaceHolders}
        clearAnalyticsPlaceHolders={actions.clearAnalyticsPlaceHolders}
        domainUrl={domainUrl}
        enablePrePayment={enablePrePayment}
      />
    );
  }

  handleRegistrationPaymentRef = node => {
    const { handleRegistrationPaymentRef } = this.props;
    if (handleRegistrationPaymentRef) {
      handleRegistrationPaymentRef(node);
    }
  };

  render() {
    const {
      titles,
      isMobileView,
      countries,
      isRtl,
      isNoPayment,
      termsAndConditions,
      registrationSubmitingStatus,
      registrationModel,
      registrationData,
      registrationModelContact,
      showContactDetailsInRegistration,
      addonsByPaxIndex,
      selectedAddonsGroup,
      onShowAddonDetailsClick,
      addonsCurosselRoomNumber,
      selectedPaxId,
      paxList,
      orderSummary,
      clubUserLoggedIn,
      clubUserData,
      totalPrices,
      clubTotalPrices,
      discountClubConfig,
      orderCurrency,
      showSimpleClubLoginModal,
      handleRegistrationFormRef,
      scrollToRegistrationForm,
      isIE,
      domainUrl,
      lang,
      showMessage,
      placeHolders,
      enableAddonsRegistration,
      payment
    } = this.props;
    const { paymentFormVisible } = this.state;
    const showClubBanner =
      !clubUserLoggedIn && discountClubConfig && discountClubConfig.Active;

    return (
      <div
        className={cx(styles.mainWrapper, {
          [styles.mobileView]: isMobileView
        })}
        ref={this.handleRegistrationPaymentRef}
      >
        <PlaceHolder
          placeHolders={placeHolders}
          component={"RegistrationPage"}
          location={"PageTop"}
        />
        {showClubBanner && (
          <ClubBanner
            totalToSave={totalPrices.totalPrice - clubTotalPrices.totalPrice}
            discountClubConfig={discountClubConfig}
            titles={titles}
            domainUrl={domainUrl}
            orderCurrency={orderCurrency}
            showSimpleClubLoginModal={showSimpleClubLoginModal}
            isMobileView={isMobileView}
            isRtl={isRtl}
          />
        )}
        {enableAddonsRegistration &&
          addonsByPaxIndex &&
          addonsByPaxIndex.length > 0 && (
            <AddonCarouselGroup
              addonsByPaxIndex={addonsByPaxIndex}
              isRtl={isRtl}
              isIE={isIE}
              isMobileView={isMobileView}
              selectedAddonsGroup={selectedAddonsGroup}
              addonsCurosselRoomNumber={addonsCurosselRoomNumber}
              onShowAddonDetailsClick={onShowAddonDetailsClick}
              onAddonRoomChanged={this.onAddonRoomChanged}
              paxList={paxList}
              titles={titles}
              orderSummary={orderSummary}
              onAddonIncrementClick={this.onAddonIncrementClick}
              selectedPaxId={selectedPaxId}
              showMessage={showMessage}
            />
          )}{" "}
        <RegistrationForm
          titles={titles}
          isMobileView={isMobileView}
          countries={countries}
          isRtl={isRtl}
          clubUserLoggedIn={clubUserLoggedIn}
          clubUserData={clubUserData}
          termsAndConditions={termsAndConditions}
          submitingStatus={registrationSubmitingStatus}
          onSubmit={this.onSubmit}
          registrationModel={registrationModel}
          registrationData={registrationData}
          showContactDetailsInRegistration={showContactDetailsInRegistration}
          registrationModelContact={registrationModelContact}
          isPaymentViewEnabled={paymentFormVisible}
          togglePaymentSection={this.togglePaymentSection}
          updateRegistrationData={this.updateRegistrationData}
          handleRegistrationFormRef={handleRegistrationFormRef}
          scrollToRegistrationForm={scrollToRegistrationForm}
          originalNoPayment={isNoPayment}
          isNoPayment={isNoPayment || (payment && payment.URL === "nopayment")}
          continueToConfirmation={this.continueToConfirmation}
          isIE={isIE}
          lang={lang}
          placeHolders={placeHolders}
          getAnalyticsPlaceHolders={
            orderSummary.length > 0
              ? this.getRegistrationAnalyticsPlaceHolders
              : null
          }
          clearAnalyticsPlaceHolders={clearAnalyticsPlaceHolders}
        />
        {paymentFormVisible && this.renderPaymentProcess()}
      </div>
    );
  }
}

RegistrationPayment.defaultProps = {
  addonsByPaxIndex: []
};

RegistrationPayment.propTypes = {
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  lang: PropTypes.string,
  rooms: PropTypes.object,
  hotelName: PropTypes.string,
  paxList: PropTypes.array,
  actions: PropTypes.object,
  clubUserLoggedIn: PropTypes.bool,
  clubUserData: PropTypes.object,
  totalPrices: PropTypes.object,
  clubTotalPrices: PropTypes.object,
  dealSearchResults: PropTypes.array,
  addonsCurosselRoomNumber: PropTypes.number,
  isDealMode: PropTypes.bool,
  countries: PropTypes.array,
  isRtl: PropTypes.bool,
  termsAndConditions: PropTypes.string,
  registrationSubmitingStatus: PropTypes.object,
  routing: PropTypes.object,
  registrationModel: PropTypes.array,
  registrationModelContact: PropTypes.array,
  registrationData: PropTypes.object,
  showContactDetailsInRegistration: PropTypes.bool,
  promoCode: PropTypes.string,
  selectedHotelId: PropTypes.string,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  isIE: PropTypes.bool,
  isNoPayment: PropTypes.bool,
  payment: PropTypes.object,
  transactionId: PropTypes.string,
  token: PropTypes.string,
  payerId: PropTypes.string,
  isPayPal: PropTypes.bool,
  totalAmountToPay: PropTypes.number,
  orderCurrency: PropTypes.object,
  isPromoCodeValid: PropTypes.bool,
  addonsByPaxIndex: PropTypes.array,
  selectedAddonsGroup: PropTypes.object,
  discountClubConfig: PropTypes.object,
  showSimpleClubLoginModal: PropTypes.func,
  selectedPaxId: PropTypes.number,
  orderSummary: PropTypes.array,
  addons: PropTypes.object,
  addonsForOrder: PropTypes.array,
  onLoad: PropTypes.func,
  handleRegistrationPaymentRef: PropTypes.func,
  handleRegistrationFormRef: PropTypes.func,
  scrollToRegistrationForm: PropTypes.func,
  onShowAddonDetailsClick: PropTypes.func,
  isGlobalFetch: PropTypes.bool,
  domainUrl: PropTypes.string,
  paymentUrlRequestStatus: PropTypes.bool,
  showMessage: PropTypes.func,
  placeHolders: PropTypes.array,
  enableAddonsRegistration: PropTypes.bool,
  enablePrePayment: PropTypes.bool
};

const mapStateToProps = store => {
  const { addonImagesLookupTable } = store;

  const regTotalPrices = getCartTotalPrices(store);
  const regClubTotalPrices = getCartTotalPrices(store, true);
  const hotelName = getSelectedHotelName(store);

  const state = {
    lang: store.lang,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate,
    paxList: availablePaxList(store),
    rooms: store.rooms,
    clubUserLoggedIn: store.clubUserLoggedIn,
    clubUserData: store.clubUserData,
    totalPrices: regTotalPrices,
    clubTotalPrices: regClubTotalPrices,
    dealSearchResults: store.dealSearchResults,
    isDealMode: store.isDealMode,
    titles: store.titles,
    isMobileView: store.isMobileView,
    countries: store.countries,
    isRtl: isRTL(store),
    termsAndConditions: store.termsAndConditions,
    registrationSubmitingStatus: store.registrationSubmitingStatus,
    registrationModel: store.registrationModel,
    registrationData: store.registrationData,
    showContactDetailsInRegistration: store.showContactDetailsInRegistration,
    registrationModelContact: store.registrationModelContact,
    routing: store.routing,
    selectedHotelId: store.selectedHotelId,
    promoCode: store.promoCode,
    isNoPayment: store.isNoPayment,
    payment: store.payment,
    totalAmountToPay: store.totalAmountToPay,
    orderCurrency: store.orderCurrency,
    isFetchingPaymentData: store.isFetchingPaymentData,
    isPromoCodeValid: store.isPromoCodeValid,
    selectedAddonsGroup: store.selectedAddonsGroup,
    discountClubConfig: store.discountClubConfig,
    selectedPaxId: store.selectedPaxId,
    orderSummary: store.orderSummary,
    addons: store.addons,
    isGlobalFetch: store.isGlobalFetch,
    addonsForOrder: store.addonsForOrder,
    addonsCurosselRoomNumber: store.addonsCurosselRoomNumber,
    domainUrl: store.domainUrl,
    paymentUrlRequestStatus: store.paymentUrlRequestStatus,
    placeHolders: store.placeHolders,
    userComments: store.userComments,
    hotelName: hotelName,
    enableAddonsRegistration: store.enableAddonsRegistration,
    addonsByPaxIndex:
      store.addons[store.addonsCurosselRoomNumber] &&
      store.addons[store.addonsCurosselRoomNumber].map(addon => {
        //TODO: this is bad practice to do in mapState, we need a memoized selector
        const bestMatch =
          stringSimilarity &&
          stringSimilarity.findBestMatch(
            addon.id,
            Object.keys(addonImagesLookupTable)
          ).bestMatch;
        const useBestMatch = bestMatch && bestMatch.rating > 0.8;
        return {
          ...addon,
          imageURL: useBestMatch
            ? addonImagesLookupTable[bestMatch.target]
            : addonImagesLookupTable.default
        };
      }),
    enablePrePayment: store.enablePrePayment
  };
  return state;
};

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    getAnalyticsPlaceHolders,
    setRegistrationData,
    setTotalAmount,
    setOrderCurrency,
    getClubLLoggedUserData,
    getPaymentData,
    setReservation,
    payPalProxy,
    replace,
    setOrderSummary,
    ...addonsActions,
    push
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationPayment);



// WEBPACK FOOTER //
// ./src/containers/RegistrationPayment/RegistrationPayment.js